

import React, { useContext, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import CloudformationOutputs from '../CloudformationOutputs.json'
import Modal from '../ui-elements/Modal'
import { getDate } from '../utils/getDate'
import { checkIfCheckPeriodIsLocked } from '../utils/checkIfCheckPeriodIsLocked'

type Props = {
    thisChecklistPeriod: ObjectStringKeyAnyValue
    thisChecklist: ObjectStringKeyAnyValue
}

function FormatCheckPeriodStartedBy({
    thisChecklistPeriod,
    thisChecklist
}: Props) {

    const {
        userData,
        loggedIn
    } = useContext(GlobalContext)



    const isCheckPeriodLocked = thisChecklistPeriod && checkIfCheckPeriodIsLocked(thisChecklistPeriod, thisChecklist, userData, loggedIn)
    const checkPeriodStartedByUserDetails = thisChecklistPeriod && thisChecklistPeriod['startedByUserDetails'] || {}

    let userString = ``

    if (checkPeriodStartedByUserDetails['loginMethod'] === 'guest') {
        userString = ` guest user `
    } else {
        userString = ` `
    }
    if (checkPeriodStartedByUserDetails['name']) {
        userString = `${userString} ${checkPeriodStartedByUserDetails['name']}`
    }
    if (checkPeriodStartedByUserDetails['email']) {
        userString = `${userString} (${checkPeriodStartedByUserDetails['email']})`
    }
    if (userString !== '') {
        userString = `${userString}`
    } else {
        userString = ` another user`
    }

    if (!thisChecklistPeriod || !thisChecklist) {
        return null
    }

    return <div className={`flex flex-row items-center gap-2 text-sm`}>

        {isCheckPeriodLocked &&
            <>
                <p className={`text-xl`}>🔐</p>
                <p>This checklist is locked because it was started by {userString}.</p>
            </>}

        {!isCheckPeriodLocked
            && thisChecklistPeriod
            && thisChecklistPeriod['startedByUserDetails'] &&
            <p>Checklist started by {userString}.</p>}
    </div>
}

export default FormatCheckPeriodStartedBy